import app from 'flarum/forum/app';

import { extend } from 'flarum/common/extend';
import Badge from 'flarum/common/components/Badge';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import Discussion from 'flarum/common/models/Discussion';

export default () => {
  extend(DiscussionList.prototype, 'requestParams', (params) => {
    params.include.push('firstPost.lottery');
  });

  extend(Discussion.prototype, 'badges', function (badges) {
    if (this.readPermission()>0) {
      badges.add(
        'readPermission',
        Badge.component({
          type: 'readPermission',
          label: app.translator.trans('nodeloc-read-permission.forum.tooltip.badge')+' >= '+this.readPermission(),
          icon: 'fas fa-seedling',
        }),
        5
      );
    }
  });
};
